import React from "react";

interface PlayerProgressBarProps {
  progress: number;
}

const PlayerProgressBar: React.FC<PlayerProgressBarProps> = ({ progress }) => (
  <div className="absolute right-0 bottom-0 left-0 z-30 h-0.5 w-full bg-neutral-50">
    <div className="bg-brand-30 h-full" style={{ width: `${progress}%` }} />
  </div>
);

export default PlayerProgressBar;
